import CustomMessage from './CustomMessage';

export default CustomMessage;
